/** Formatierung (deutsch). Geldbeträge sind immer ganze Cent. */
const eur = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
const num = new Intl.NumberFormat('de-DE');
const pct = new Intl.NumberFormat('de-DE', { style: 'percent', maximumFractionDigits: 1 });

export const fmtEur = (cents: number | null | undefined): string => (cents == null ? '–' : eur.format(cents / 100));
/** Mit Vorzeichen, z. B. "+1,50 €" */
export const fmtEurSigned = (cents: number): string => (cents > 0 ? '+' : '') + eur.format(cents / 100);
export const fmtNum = (n: number | null | undefined): string => (n == null ? '–' : num.format(n));
/** 0.123 -> "12,3 %" */
export const fmtPct = (ratio: number | null | undefined): string => (ratio == null || !Number.isFinite(ratio) ? '–' : pct.format(ratio));

/** Parst "12,34" / "12.34" / "1.234,56" -> Cent. NaN bei ungültig. */
export function parseEur(input: string): number {
  let s = input.trim().replace(/€/g, '').replace(/\s/g, '');
  if (!s) return NaN;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  const n = Number(s);
  return Number.isFinite(n) ? Math.round(n * 100) : NaN;
}

/** Cent -> Eingabetext "12,34" */
export const centsToInput = (c: number | null | undefined): string => (c == null ? '' : (c / 100).toFixed(2).replace('.', ','));

const tz = 'Europe/Berlin';
export const fmtDateTime = (ms: number | null | undefined) =>
  ms == null ? '–' : new Date(ms).toLocaleString('de-DE', { timeZone: tz, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
export const fmtTime = (ms: number | null | undefined) =>
  ms == null ? '–' : new Date(ms).toLocaleTimeString('de-DE', { timeZone: tz, hour: '2-digit', minute: '2-digit' });
/** 'YYYY-MM-DD' -> "Mi., 07.10.2026" */
export const fmtDate = (date: string | null | undefined, opts: { weekday?: boolean } = { weekday: true }) => {
  if (!date) return '–';
  const d = new Date(date + 'T12:00:00Z');
  return d.toLocaleDateString('de-DE', { timeZone: 'UTC', weekday: opts.weekday ? 'short' : undefined, day: '2-digit', month: '2-digit', year: 'numeric' });
};
export const fmtRelative = (ms: number | null | undefined) => {
  if (ms == null) return '–';
  const diff = Date.now() - ms;
  const m = Math.round(diff / 60000);
  if (m < 1) return 'gerade eben';
  if (m < 60) return `vor ${m} Min.`;
  const h = Math.round(m / 60);
  if (h < 24) return `vor ${h} Std.`;
  const d = Math.round(h / 24);
  return `vor ${d} Tag${d === 1 ? '' : 'en'}`;
};
export const fmtBytes = (n: number) => (n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(0)} KB` : `${(n / 1048576).toFixed(1)} MB`);

/** Zufällige UUID (für Idempotenz von Verkäufen). */
export const uuid = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
